// extracted by mini-css-extract-plugin
export var breadcrumb = "_17-3";
export var breadcrumbArrow = "_17-4";
export var breadcrumbs = "_17-0";
export var link = "_17-5";
export var sm = "_17-1";
export var xs = "_17-2";